// extracted by css-extract-rspack-plugin
export default {"stateContextPanel":"RqNDoH8eCmglUVOk","failedState":"aHrmnNJWO48IbCQq","buildState":"hOG046s0WocA_eiX","darkState":"ZGtuLwr0Qv8C83W1","iconLink":"e_wgmAg1RiYeIh1q"};